<div class=" container-fluid mt-4">
    <!-- Row -->
    <div class="">
        <div class="row">
            <div class="col-lg-12">
                <div class="d-flex justify-content-between align-items-center m-3">
                    <h5 class="font-medium m-0">Complete Detail Of Auditor</h5>
                </div>
            </div>

            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="mb-3 d-flex justify-content-between">
                            <div class="d-flex align-items-center gap-2">
                                <!-- Add Remark Button -->
                                <button type="button"
                                    [style.display]="hideRemark || hideARemarks ? 'none' : 'inline-block'"
                                    class="btn btn-primary btn-sm" data-bs-toggle="modal"
                                    data-bs-target="#ChecklistRemark">
                                    Add Remark
                                </button>

                                <!-- Update Audit Status Button -->
                                <button type="button"
                                    [style.display]="hidebutton || hideARemarks ? 'none' : 'inline-block'"
                                    class="btn btn-primary btn-sm" data-bs-toggle="modal"
                                    data-bs-target="#ChecklistStatusReport">
                                    Update Audit Status
                                </button>

                            </div>
                            <div class="d-flex align-items-center gap-2">
                                <!-- <button                              
                                    class="btn btn-primary btn-sm"
                                    [attr.href]="auditStatus?.documentPath" download>
                                    Download Report
                                </button> -->
                                <button class="btn btn-primary btn-sm" (click)="downloadDocument()">
                                    Download Report
                                </button>
                                <!-- <select class="form-control" style="width: 150px;">
                                    <option>Select Date</option>
                                    <option>XX/XX/XXXX</option>
                                </select> -->
                            </div>
                            <!-- <p *ngIf="!auditStatus.documentPath" class="text-muted">No report available</p> -->
                        </div>
                        <!-- <div class="d-flex justify-content-between align-items-center mb-3">
                            <h5 class="m-0">Complete Detail Of Society</h5>
                            <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#ChecklistStatusReport">
                                Check Status
                              </button>
                        </div> -->
                        <div class="accordion" id="accordianAuditReports">
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        Society Information
                                    </button>
                                </h2>
                                <div id="collapseOne" class="accordion-collapse collapse show"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">
                                        <div class="row align-items-end">
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Name:</label>
                                                    <p class="m-0">{{ societyDetailData[0]?.sSocietyName }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Registration No:</label>
                                                    <p class="m-0">{{ societyDetailData[0]?.sSocietyRegistrationNo }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Registration Date:</label>
                                                    <p class="m-0">{{ societyDetailData[0]?.dFinishApplicationdate |
                                                        date:'dd/MM/yyyy' }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Address:</label>
                                                    <p class="m-0">{{ societyDetailData[0]?.address }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Level:</label>
                                                    <p class="m-0">{{ societyDetailData[0]?.level }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Sector:</label>
                                                    <p class="m-0">{{ societyDetailData[0]?.society }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-4">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Type:</label>
                                                    <p class="m-0">{{ societyDetailData[0]?.type }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2"></div>
                                            <div class="col-md-4 mb-2"></div>


                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Society Building:</label>
                                                    <p class="m-0">{{ societyDetailData[0]?.societyBuilding }}</p>
                                                </div>
                                            </div>

                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Type Of Building:</label>
                                                    <p class="m-0">{{ societyDetailData[0]?.buildingType}}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Remarks:</label>
                                                    <p class="m-0">{{ societyDetailData[0]?.sRemarks }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Land Details:</label>
                                                    <p class="m-0">{{ societyDetailData[0]?.landDetails}}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Type Of Possession:</label>
                                                    <p class="m-0">{{ societyDetailData[0]?.possessionType}}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Area(In Acres):</label>
                                                    <p class="m-0">{{ societyDetailData[0]?.sArea }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        Basic Common Parameters
                                    </button>
                                </h2>
                                <div id="collapseTwo" class="accordion-collapse collapse"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">
                                        <div class="row align-items-end">
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Status of Societies:</label>
                                                    <p class="m-0">{{ basicCommonParameterData?.statusSocieties }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">For Cooperative Bank:</label>
                                                    <p class="m-0">{{
                                                        basicCommonParameterData?.isCorporativeBank==1?'Yes':'No' }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-4">
                                                    <label class="form-label m-0">Cooperative Bank Branches:</label>
                                                    <p class="m-0">{{
                                                        basicCommonParameterData?.isCorporativeBank==1?'Yes':'No' }}</p>
                                                </div>
                                            </div>

                                            <div class="col-md-12 mb-12">
                                                <div class="d-flex align-items-center gap-3">
                                                    <h6>Number of member for secondary and apex institute societies</h6>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-12">
                                                <div class="d-flex align-items-center gap-3">
                                                    <h6>Number of members for primary societies</h6>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Gender :</label>
                                                    <p class="m-0">{{ basicCommonParameterData?.gender == 20 ? 'Male' :
                                                        'Female' }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Total Member :</label>
                                                    <!-- <p class="m-0">{{ basicCommonParameterData?.gender == 20 ? 'Male' : 'Female' }}</p> -->
                                                    <p class="m-0">120</p>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-12">
                                                <div class="d-flex align-items-center gap-3">
                                                    <h6>Managing Committee Details</h6>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">No. of Members:</label>
                                                    <p class="m-0">{{ basicCommonParameterData?.memberCommitee }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Elected Member:</label>
                                                    <p class="m-0">{{ basicCommonParameterData?.electedMember }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Vacant (if any):</label>
                                                    <p class="m-0">{{ basicCommonParameterData?.vacantMember }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-12">
                                                <div class="d-flex align-items-center gap-3">
                                                    <h5>Employee Details</h5>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Trained Employees:</label>
                                                    <p class="m-0">{{ basicCommonParameterData?.trainedEmp }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Untrained Employees:</label>
                                                    <p class="m-0">{{ basicCommonParameterData?.unTrainedEmp }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Full Time Secretaries (Paid):</label>
                                                    <p class="m-0">{{ basicCommonParameterData?.fullTimeSC }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Part Time Secretaries (Paid):</label>
                                                    <p class="m-0">{{ basicCommonParameterData?.partTimeSC }}</p>
                                                </div>
                                            </div>

                                            <div class="col-md-12">

                                                <ngx-datatable
                                                    class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                                    [rows]="lstEmployeesData" [columns]="columns" [columnMode]="'force'"
                                                    [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                                                    [externalPaging]="false" [virtualization]="false"
                                                    [scrollbarV]="false" [scrollbarH]="true">

                                                    <ngx-datatable-column name="#" [sortable]="false">
                                                        <ng-template let-rowIndex="rowIndex"
                                                            ngx-datatable-cell-template>
                                                            <span>{{ rowIndex + 1 }}</span>
                                                        </ng-template>
                                                    </ngx-datatable-column>


                                                    <!-- Dynamic Columns -->
                                                    <ngx-datatable-column *ngFor="let column of columns"
                                                        [sortable]="true" [name]="column.name" [prop]="column.prop">
                                                        <ng-template ngx-datatable-cell-template let-value="value">
                                                            {{ value }}
                                                        </ng-template>
                                                    </ngx-datatable-column>


                                                </ngx-datatable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree" aria-expanded="false"
                                        aria-controls="collapseThree">
                                        Business Turnover of Services
                                    </button>
                                </h2>
                                <div id="collapseThree" class="accordion-collapse collapse"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">
                                        <div class="row align-items-end">
                                            <div class="col-lg-12">
                                                <h6 class="mt-3"></h6>
                                            </div>

                                            <div class="col-md-12" *ngFor="let business of lstBussinessUpgrade">
                                                <hr class="underline" />

                                                <!-- Display Service Name Above the Table -->
                                                <h6 class="service-title">{{ business.name }}</h6>
                                                <hr class="underline" />


                                                <ngx-datatable
                                                    class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                                    [rows]="business.lstServiceData" [columns]="col"
                                                    [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
                                                    rowHeight="auto" [externalPaging]="false" [virtualization]="false"
                                                    [scrollbarV]="false" [scrollbarH]="true">

                                                    <!-- S.No. Column -->
                                                    <ngx-datatable-column name="#" [sortable]="false">
                                                        <ng-template let-rowIndex="rowIndex"
                                                            ngx-datatable-cell-template>
                                                            <span>{{ rowIndex + 1 }}</span>
                                                        </ng-template>
                                                    </ngx-datatable-column>

                                                    <!-- Dynamic Columns -->
                                                    <ngx-datatable-column *ngFor="let column of col" [sortable]="true"
                                                        [name]="column.name" [prop]="column.prop">
                                                        <ng-template ngx-datatable-cell-template let-value="value">
                                                            {{ value }}
                                                        </ng-template>
                                                    </ngx-datatable-column>

                                                </ngx-datatable>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseFour" aria-expanded="false"
                                        aria-controls="collapseFour">
                                        Common Audit Parameters
                                    </button>
                                </h2>
                                <div id="collapseFour" class="accordion-collapse collapse"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">
                                        <div class="row align-items-end">
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Audit Year :</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sAuditYear }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Audit Classification :</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sAuditClassification }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Name Of Auditor :</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sAuditorName }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Audit Allotment Date:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.dAuditAllotmentDate }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Audit Start Date:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.dAuditStartDate }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Submit Date:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.dSubmitDate }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Date Of Election:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.dDateOfElection }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">General House Meeting:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.dGeneralHouseMeeting }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Income:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sIncome }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Expenditure:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sExpenditure }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Profit:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sProfit }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Loss:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sLoss }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">GST No:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sGSTNO }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">PAN No:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sPANNo }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">TAN No:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sTanNo }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">EPF No:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sEPFNo }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Is Special Report:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.IsSpecialReport }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Working Capital:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sWorkingCapital }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Audit Fee:</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sAuditFee }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-4">
                                                <div class="d-flex align-items-center gap-3">
                                                    <h6>Misappropriation/Embezzlement</h6>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Amount Involved :</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sAmountInvolved }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Date Of Detection :</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sDateOfDetection }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Total Share Capital :</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.totalshare }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Members :</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.member }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Have Any Government Share :</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.govtshares == 1 ? 'Yes'
                                                        : 'No' }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-12"
                                                *ngIf="commonAuditParametersData?.govtshares  !== 0 && commonAuditParametersData?.govtshares != null">
                                                <div class="row">
                                                    <div class="col-md-4 mb-2">
                                                        <div class="d-flex align-items-center gap-3">
                                                            <label class="form-label m-0">Government share :</label>
                                                            <p class="m-0">{{ commonAuditParametersData?.govtShare }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 mb-2">
                                                        <div class="d-flex align-items-center gap-3">
                                                            <label class="form-label m-0">Redemption of government share
                                                                :</label>
                                                            <p class="m-0">{{
                                                                commonAuditParametersData?.redemptionGovtShare }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 mb-2">
                                                        <div class="d-flex align-items-center gap-3">
                                                            <label class="form-label m-0">Government dividend payable
                                                                :</label>
                                                            <p class="m-0">{{
                                                                commonAuditParametersData?.govtDividentPayable}}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 mb-2">
                                                        <div class="d-flex align-items-center gap-3">
                                                            <label class="form-label m-0">Government dividend paid
                                                                :</label>
                                                            <p class="m-0">{{
                                                                commonAuditParametersData?.govtDividentPaid }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 mb-2">
                                                        <div class="d-flex align-items-center gap-3">
                                                            <label class="form-label m-0">Government Loan :</label>
                                                            <p class="m-0">{{ commonAuditParametersData?.govtLoan }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 mb-2">
                                                        <div class="d-flex align-items-center gap-3">
                                                            <label class="form-label m-0">Recovery of principal and
                                                                interest :</label>
                                                            <p class="m-0">{{
                                                                commonAuditParametersData?.recoveryOfPrincipalInt }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 mb-2">
                                                        <div class="d-flex align-items-center gap-3">
                                                            <label class="form-label m-0">Specify any other
                                                                facilities/services/businesses carried out by the
                                                                Pacs(if Any) :</label>
                                                            <p class="m-0">
                                                                {{commonAuditParametersData?.specifyFacilitiesService}}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseFive" aria-expanded="false"
                                        aria-controls="collapseFive">
                                        Credit Cooperative Societies
                                    </button>
                                </h2>
                                <div id="collapseFive" class="accordion-collapse collapse"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">
                                        <div class="row align-items-end">
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Loan to Agriculture(in year) :</label>
                                                    <p class="m-0">{{ dataCooperative?.sLoanAgriculture }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Loan to Non-Agriculture(in year)
                                                        :</label>
                                                    <p class="m-0">{{ dataCooperative?.sLoanNonAgriculture }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <h6>Loan Distribution</h6>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Short Term(in year) :</label>
                                                    <p class="m-0">{{ dataCooperative?.sLoanDistributionShort}}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Medium Term(in year) :</label>
                                                    <p class="m-0">{{ dataCooperative?.sLoanDistributionMedium }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Long Term(in year) :</label>
                                                    <p class="m-0">{{ dataCooperative?.sLoanDistributionLong }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <h6>Loan Recovery</h6>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Short Term(in year) :</label>
                                                    <p class="m-0">{{ dataCooperative?.sLoanRecoveryShort}}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Medium Term(in year) :</label>
                                                    <p class="m-0">{{ dataCooperative?.sLoanRecoveryMedium }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Long Term(in year) :</label>
                                                    <p class="m-0">{{ dataCooperative?.sLoanRecoveryLong}}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <h6>Loan Outstanding</h6>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Short Term(in year) :</label>
                                                    <p class="m-0">{{ dataCooperative?.sLoanOutstandingShort }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Medium Term(in year) :</label>
                                                    <p class="m-0">{{ dataCooperative?.sLoanOutstandingMedium }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Long Term(in year) :</label>
                                                    <p class="m-0">{{ dataCooperative?.sLoanOutstandingLong }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <h6>Loan Overdue</h6>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Short Term(in year) :</label>
                                                    <p class="m-0">{{ dataCooperative?.sLoanOverdueShort }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Medium Term(in year) :</label>
                                                    <p class="m-0">{{ dataCooperative?.sLoanOverdueMedium }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-4 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Long Term(in year) :</label>
                                                    <p class="m-0">{{dataCooperative?.sLoanOverdueLong}}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <h6>Borrowers Details</h6>
                                                </div>
                                            </div>


                                            <div class="col-md-12">

                                                <ngx-datatable
                                                    class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                                    [rows]="lstBorrowerDetailsData" [columns]="columnss"
                                                    [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50"
                                                    rowHeight="auto" [externalPaging]="false" [virtualization]="false"
                                                    [scrollbarV]="false" [scrollbarH]="true">

                                                    <ngx-datatable-column name="#" [sortable]="false">
                                                        <ng-template let-rowIndex="rowIndex"
                                                            ngx-datatable-cell-template>
                                                            <span>{{ rowIndex + 1 }}</span>
                                                        </ng-template>
                                                    </ngx-datatable-column>


                                                    <!-- Dynamic Columns -->
                                                    <ngx-datatable-column *ngFor="let column of columnss"
                                                        [sortable]="true" [name]="column.name" [prop]="column.prop">
                                                        <ng-template ngx-datatable-cell-template let-value="value">
                                                            {{ value }}
                                                        </ng-template>
                                                    </ngx-datatable-column>


                                                </ngx-datatable>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                        Non - Credit Cooperative Societies
                                    </button>
                                </h2>
                                <div id="collapseSix" class="accordion-collapse collapse"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">
                                        <div class="row align-items-end">
                                            <div class="col-md-12">
                                                <h6 class="text-medium">
                                                    Educational and Training Cooperative/ Apex HIMCOFED/ HIMCAPES
                                                </h6>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">
                                                    No of Training Conducted:
                                                </label>
                                                <p class="form-control-static">{{ newnonCredit.sTrainingNo || 'N/A' }}
                                                </p>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">
                                                    Specific Training Areas (for financial year):
                                                </label>
                                                <p class="form-control-static">{{ newnonCredit.sSpecificAuditYearArea ||
                                                    'N/A' }}</p>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">
                                                    No of Trained Professionals:
                                                </label>
                                                <p class="form-control-static">{{ newnonCredit.sNoTrainedConducted ||
                                                    'N/A' }}</p>
                                            </div>

                                            <div class="col-md-12">
                                                <h6 class="text-medium">Number of Workers</h6>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">
                                                    Teaching Staff:
                                                </label>
                                                <p class="form-control-static">{{ newnonCredit.sNoTeachingWorkers ||
                                                    'N/A' }}</p>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">
                                                    Other Staff:
                                                </label>
                                                <p class="form-control-static">{{ newnonCredit.sNoOtherStaff || 'N/A' }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseSeven" aria-expanded="false"
                                        aria-controls="collapseSix">
                                        Audit Parameters
                                    </button>
                                </h2>
                                <div id="collapseSeven" class="accordion-collapse collapse"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">
                                        <div class="row align-items-end">
                                            <div class="col-md-6 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Total outstanding loan extended to
                                                        members in last financial year :</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sAuditorName }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <label class="form-label m-0">Last financial revenue(oter than
                                                        interest) from non-credit activities :</label>
                                                    <p class="m-0">{{ commonAuditParametersData?.sAuditorName }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-12 mb-2">
                                                <div class="d-flex align-items-center gap-3">
                                                    <h6>Balance Sheet</h6>
                                                </div>
                                            </div>

                                            <div class="row">


                                                <!-- Liabilities Table -->
                                                <div class="col-lg-6 mt-3">
                                                    <ngx-datatable
                                                        class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                                        [rows]="rowsesLiabilities" [columnMode]="'force'"
                                                        [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                                                        [externalPaging]="true" [count]="rowsesLiabilities.length"
                                                        [limit]="10" [virtualization]="false" [scrollbarV]="false"
                                                        [scrollbarH]="true">

                                                        <ngx-datatable-column name="#" [sortable]="false">
                                                            <ng-template ngx-datatable-cell-template
                                                                let-rowIndex="rowIndex">
                                                                <span>{{ rowIndex + 1 }}</span>
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <ngx-datatable-column name="Liabilities" [sortable]="true">
                                                            <ng-template ngx-datatable-cell-template let-row="row">
                                                                <span>{{ row.sParameterType }}</span>
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <ngx-datatable-column name="Amount" [sortable]="true">
                                                            <ng-template ngx-datatable-cell-template let-row="row">
                                                                <span>{{ row.sAmount }}</span>
                                                            </ng-template>
                                                        </ngx-datatable-column>
                                                    </ngx-datatable>
                                                </div>

                                                <!-- Assets Table -->
                                                <div class="col-lg-6 mt-3">
                                                    <ngx-datatable
                                                        class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                                        [rows]="rowsAssets" [columnMode]="'force'" [headerHeight]="50"
                                                        [footerHeight]="50" rowHeight="auto" [externalPaging]="true"
                                                        [count]="rowsAssets.length" [limit]="10"
                                                        [virtualization]="false" [scrollbarV]="false"
                                                        [scrollbarH]="true">

                                                        <ngx-datatable-column name="#" [sortable]="false">
                                                            <ng-template ngx-datatable-cell-template
                                                                let-rowIndex="rowIndex">
                                                                <span>{{ rowIndex + 1 }}</span>
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <ngx-datatable-column name="Assets" [sortable]="true">
                                                            <ng-template ngx-datatable-cell-template let-row="row">
                                                                <span>{{ row.sParameterType }}</span>
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <ngx-datatable-column name="Amount" [sortable]="true">
                                                            <ng-template ngx-datatable-cell-template let-row="row">
                                                                <span>{{ row.sAmount }}</span>
                                                            </ng-template>
                                                        </ngx-datatable-column>
                                                    </ngx-datatable>
                                                </div>



                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>






</div>
<!-- 
<div class="modal fade" id="ChecklistRemark" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="ChecklistStatusReportLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="ChecklistStatusReportLabel">Remark</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12 mb-2">
                        <select name="" id="" class="form-control">
                            <option value="" selected disabled>Select Role</option>

                        </select>
                    </div>
                    <div class="col-md-12 mb-2">
                        <div class="d-flex align-items-center justify-content-between gap-2">
                            <h6 class="m-0">Remark / Objection from District Registrar</h6>
                            <p class="fs-14px m-0">Date: DD/MM/YYYY</p>
                        </div>
                    </div>

                    <div class="col-md-12 mb-2">
                        <textarea name="" id="" class="form-control" rows="3" readonly
                            placeholder="Reason for Sendback"></textarea>
                    </div>
                    <div class="col-md-12 mb-2">
                        <div class="d-flex align-items-center gap-2">
                            <button type="button" class="btn btn-outline-info btn-sm">Download File</button>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <h5>Add Your Remark</h5>
                    </div>
                    <form #remarkForm="ngForm" (ngSubmit)="updateRemark(remarkForm)">
                        <div class="col-md-12 mb-2">
                            <label class="form-label">Remark <span class="text-danger">*</span></label>
                            <textarea class="form-control" rows="3" placeholder="Enter Remark Here..." name="remark"
                                [(ngModel)]="remark" #remarkRef="ngModel" required>
                        </textarea>
                            <div *ngIf="remarkRef.invalid && remarkRef.touched" class="text-danger">
                                Remark is required.
                            </div>
                        </div>

                        <div class="col-md-12 mb-3">
                            <label for="DistrictAuditorUploadFile" class="form-label">Upload file</label>
                            <input class="form-control" type="file" id="DistrictAuditorUploadFile">
                        </div>

                        <div class="col-md-12 text-end">
                            <button type="submit" class="btn btn-primary" [disabled]="remarkForm.invalid">
                                Update Remark
                            </button>
                        </div>
                    </form>

                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div> -->
<div class="modal fade" id="ChecklistRemark" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="ChecklistStatusReportLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title" id="ChecklistStatusReportLabel">Auditor Remark <span
                        class="text-danger">*</span></h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <!-- Existing Remark Display -->
                <div class="col-md-12 mb-3">
                    <!-- <label class="form-label"><strong>Auditor Remark:</strong></label> -->
                    <textarea class="form-control" rows="3" placeholder="No remarks available"
                        [(ngModel)]="auditStatus.sRemark" disabled></textarea>
                </div>
                <!-- Form for Adding Departmental Remark -->
                <div class="col-md-12">
                    <h5>Departmental Remark</h5>

                    <form #deptRemarkForm="ngForm" (ngSubmit)="updateRemark(deptRemarkForm)">
                        <div class="col-md-12 mb-2">
                            <!-- <label class="form-label">Remark <span class="text-danger">*</span></label> -->
                            <textarea class="form-control" rows="3" placeholder="Enter Remark Here..." name="deptRemark"
                                [(ngModel)]="DepUpload.sDepartmentalRemark" #remark="ngModel" required
                                [disabled]="!existingDeptRemark"></textarea>
                            <div *ngIf="remark.invalid && remark.touched" class="text-danger">
                                Remark is required.
                            </div>
                        </div>

                        <!-- Hide file upload when existingDeptRemark is true -->
                        <div class="col-md-12 mb-3" *ngIf="existingDeptRemark">
                            <label for="deptUploadFile" class="form-label">Upload File</label>
                            <input class="form-control" type="file" id="deptUploadFile" (change)="onFileChange($event)"
                                name="document" [(ngModel)]="DepUpload.DepartmentalRemarkDocument">
                        </div>

                        <div class="text-end" *ngIf="existingDeptRemark">
                            <button type="submit" class="btn btn-primary" data-bs-dismiss="modal"
                                [disabled]="deptRemarkForm.invalid">Update Remark</button> &nbsp;
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </form>
                </div>

                <hr>

                <!-- Form for Adding AR Remark - Only Show When Departmental Remark Exists -->
                <div class="col-md-12" *ngIf="!existingDeptRemark">
                    <h5>Add AR Remark</h5>

                    <form #arRemarkForm="ngForm" (ngSubmit)="updateArRemark(arRemarkForm)">
                        <div class="col-md-12 mb-2">
                            <label class="form-label">Remark <span class="text-danger">*</span></label>
                            <textarea class="form-control" rows="3" placeholder="Enter Remark Here..." name="arRemark"
                                [(ngModel)]="ARnewUpload.sDepartmentalRemark" #arRemarkRef="ngModel"
                                required></textarea>
                            <div *ngIf="arRemarkRef.invalid && arRemarkRef.touched" class="text-danger">
                                Remark is required.
                            </div>
                        </div>


                        <!-- Hide file upload when existingDeptRemark is true -->
                        <div class="col-md-12 mb-3">
                            <label for="arUploadFile" class="form-label">Upload File</label>
                            <input class="form-control" type="file" id="arUploadFile" (change)="onFileChange($event)"
                                name="document" [(ngModel)]="ARnewUpload.DepartmentalRemarkDocument">
                        </div>
                        <div class="text-end">
                            <button type="submit" class="btn btn-primary" data-bs-dismiss="modal"
                                [disabled]="arRemarkForm.invalid">Update Remark</button> &nbsp;
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </form>
                </div>

            </div>


        </div>
    </div>
</div>

<!--Audit Status Modal Start-->
<div class="modal fade" id="ChecklistStatusReport" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="ChecklistStatusReportLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="ChecklistStatusReportLabel">Audit Status</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row align-items-end">
                    <div class="col-md-12 mb-2">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="AuditStatusCheck"
                                [(ngModel)]="isAuditChecked" name="auditChecked">
                            <label class="form-check-label" for="AuditStatusCheck">
                                <strong>Disclaimer:</strong> Hereby, if you tick this checkbox, it will signify that you
                                have also verified the manual reports submitted by the Auditor.
                            </label>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <form #statusForm="ngForm" (ngSubmit)="updateStatus(statusForm)">
                            <div class="row align-items-end">
                                <div class="col-md-6 mb-3">
                                    <label for="" class="form-label">Select Status</label>
                                    <select [(ngModel)]="ddlStatus" class="form-control" name="ddlStatus" id="ddlStatus"
                                        #statusRef="ngModel" required>
                                        <option value="" disabled>Select Status</option>
                                        <option value="MoveForwardToAR" *ngIf="roleid !==13">MoveForward</option>
                                        <option value="MoveForwardToARApproved" *ngIf="roleid ==13">Approved</option>
                                        <option value="InSendBack">SendBack</option>
                                    </select>
                                </div>
                                <div class="col-lg-6 mb-3 text-end">
                                    <button type="submit" class="btn btn-primary"
                                        [disabled]="statusForm.invalid || !isAuditChecked">
                                        Update Status
                                    </button>
                                    <!-- <button type="button" (click)="UpdateStatus(iSocietyDetailsId)"
                                    class="btn btn-primary btn-sm">Update Status</button> -->
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="step-progressbar">
                                    <div class="v-progress">
                                        <ul>
                                            <li *ngFor="let process of lstAuditProcess" class="{{ process.status }}">
                                                {{ process.statusname }} <br>
                                                <small style="font-size: 12px;">{{ process.dCreateDate |
                                                    date:'dd/MM/yyyy' }}</small>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <!-- <button type="button" class="btn btn-primary">Understood</button> -->
            </div>
        </div>
    </div>
</div>
<!--Audit Status Modal End-->